import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import get from 'lodash/get';
import keys from 'lodash/keys';
import { FullPageLoader } from 'nallian-shared-ui/lib/modules';
import { GetUserLoading, GetTheme, GetThemeTag } from 'nallian-shared-ui/lib/selectors';
import withTheme from 'nallian-shared-ui/lib/hoc/withTheme';

export default ComposedComponent => {
  const service = props =>
    props.themeLoading || !props.themeTag ? (
      <FullPageLoader active content={props.t('loadingApplication')} />
    ) : (
      <ComposedComponent {...props} />
    );

  service.propTypes = {
    userLoading: PropTypes.bool,
  };

  service.defaultProps = {
    userLoading: true,
  };

  const mapStateToProps = state => ({
    userLoading: GetUserLoading(state),
    themeLoading: get(keys(GetTheme(state)), 'length', 0) === 0,
    themeTag: GetThemeTag(state),
  });

  return compose(withTranslation('shared'), withTheme, connect(mapStateToProps))(service);
};
